module.exports = __webpack_public_path__ + "img/chapter__2_image_3.f08d824f.png";